<template>
  <div class="relative">
    <div
      class="h-11 px-3 flex items-center justify-between gap-4 rounded hover:bg-hover-state cursor-pointer"
      :class="{ 'bg-slate-300': isActive }"
      @click="$emit('change-select', room.id)"
    >
      <div class="flex truncate">
        <div class="min-w-12 flex truncate" :title="room.name">
          <BlTextSubtitle3 class="truncate" :text="room.name" />
        </div>
      </div>
      <div v-if="isActive" class="flex items-center gap-2">
        <div
          v-if="enableBranch && room.branch_id"
          class="h-7 min-w-12 max-w-32 px-2 flex items-center justify-center rounded truncate"
          :style="{ backgroundColor: room.branch.background_color || 'unset' }"
          :title="room.branch.name || '-'"
        >
          <BlTextBody2
            class="truncate"
            :text="room.branch.name || '-'"
            :style="{ color: room.branch.color || 'unset' }"
          />
        </div>
        <BlInputButton
          v-if="currentUser.role.includes('admin')"
          @clicked="editOpened = true"
          icon="edit"
          type="plain"
          class="hover:bg-hover-state w-6 h-6 flex items-center justify-center mr-2"
          title="Edit room"
        />
      </div>
    </div>
    <BlBackdrop
      v-if="editOpened"
      title="Edit room"
      label="Update"
      :disabled="isDisabledSubmit"
      @backdrop-close="editOpened = false"
      @backdrop-action="onUpdate"
    >
      <div class="relative px-8 flex flex-col gap-4">
        <BlInputText :input="nameInput" @changed="inputHandler" />
        <BlSelectBox
          v-if="enableBranch"
          type="branch"
          label="Branch"
          placeholder="Select branch"
          v-model="branchInput"
          :options="branchOptions"
          search
          @change="branchInput = $event"
        />
        <div class="absolute left-8 -bottom-14 z-10">
          <BlTooltip :tooltip="''">
            <BlInputButton
              type="plain-error"
              icon="trash"
              label="Delete Room"
              :disabled="false"
              @clicked="deleteOpened = true"
            />
          </BlTooltip>
        </div>
      </div>
    </BlBackdrop>
    <BlBackdrop
      v-if="deleteOpened"
      :title="`Delete the room`"
      :label="`Delete`"
      type="error"
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onRemove"
      :disabled="deleteLoading"
    >
      <div class="px-8">
        <div class="mb-2">
          <BlTextBody2 text="You are about to delete the" />
          <BlTextBody2 :text="`${room.name}`" class="font-bold" />
          <BlTextBody2
            text="from the clinic. Are you sure you want to proceed?"
          />
        </div>
        <div>
          <BlTextBody2 text="This action is irreversible." />
        </div>
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlBackdrop from "../../BlBackdrop.vue";
import BlInputText from "../../BlInputText.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import BlTooltip from "../../BlTooltip.vue";

export default {
  name: "PackageItem",
  components: {
    BlTextSubtitle3,
    BlTextBody2,
    BlInputButton,
    BlBackdrop,
    BlInputText,
    BlSelectBox,
    BlTooltip
  },
  props: {
    room: { type: Object, required: true },
    isActive: { type: Boolean, default: false }
    // @change-select(value)
  },
  data() {
    return {
      editOpened: false,
      editLoading: false,
      nameInput: {
        label: "Room name",
        asterisk: true,
        placeholder: "Type the name",
        model: ""
      },
      branchInput: [],
      deleteOpened: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "branches"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    branchOptions() {
      return this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
    },
    isDisabledSubmit() {
      if (this.editLoading) return true;
      if (!this.nameInput.model) return true;
      return false;
    }
  },
  watch: {
    editOpened(val) {
      if (val) {
        this.nameInput.model = this.room.name;
        this.branchInput = this.room.branch_id;
      }
    }
  },
  methods: {
    ...mapActions(["updateRoom", "deleteRoom"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onUpdate() {
      const data = {
        id: this.room.id,
        room: {
          name: this.nameInput.model,
          branch_id: this.branchInput
        }
      };
      this.editLoading = true;
      this.updateRoom(data).then(({ success }) => {
        this.editLoading = false;
        if (!success) return;
        this.editOpened = false;
      });
    },
    onRemove() {
      this.deleteLoading = true;
      this.deleteRoom(this.room).then(({ success }) => {
        this.deleteLoading = false;
        if (!success) return;
        this.editOpened = false;
        this.deleteOpened = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/availabilities/room/Item.vue